import qs from 'query-string';
import { API_ENDPOINT } from '../../resources/@types/apiEndpoint';
import { useClientApiV1InstructorsIdProfileQuery } from '../../resources/@types/uccSchema';

interface ClientApiV1InstructorsIdProfileQueryString {
  lang?: string;
}

export default function useInstructorProfileQuery({
  userId,
  isInstructor,
  queryObject,
}: {
  userId: string;
  isInstructor: boolean;
  queryObject?: ClientApiV1InstructorsIdProfileQueryString;
}) {
  return useClientApiV1InstructorsIdProfileQuery({
    queryKey: getUseClientApiV1InstructorsIdProfileQueryKey(userId),
    url: getUseClientApiV1InstructorsIdProfileQueryUrl({ userId, ...queryObject }),
    options: {
      enabled: isInstructor,
      keepPreviousData: true,
      staleTime: 1_000 * 60 * 3,
    },
  });
}

export const getUseClientApiV1InstructorsIdProfileQueryKey = (userId: string) => [
  API_ENDPOINT.CLIENT_V1_INSTRUCTORS_ID_PROFILE(userId),
];

export const getUseClientApiV1InstructorsIdProfileQueryUrl = ({
  userId,
  ...queryObject
}: { userId: string } & ClientApiV1InstructorsIdProfileQueryString) =>
  qs.stringifyUrl({
    url: API_ENDPOINT.CLIENT_V1_INSTRUCTORS_ID_PROFILE(userId),
    query: { ...queryObject },
  });
